import { useCallback, useState } from 'react';

/**
 * 화면별 표시 모드(카드/테이블/…) — 화면마다 다르고 사람마다 취향이 갈리므로 localStorage에 남긴다.
 * 필터와 달리 "데이터를 좁히는 조건"이 아니라 "보는 방식"이라 BoardProvider가 아니라 화면이 갖는다.
 */
export function useViewMode<T extends string>(storageKey: string, fallback: T): [T, (next: T) => void] {
  const [mode, setMode] = useState<T>(() => (readStored(storageKey) as T | null) ?? fallback);

  const update = useCallback(
    (next: T) => {
      setMode(next);
      try {
        window.localStorage.setItem(storageKey, next);
      } catch {
        // 사파리 프라이빗 모드 등에서 쓰기가 막힐 수 있다 — 저장 실패가 화면을 막지는 않게 한다.
      }
    },
    [storageKey],
  );

  return [mode, update];
}

function readStored(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}
